export default {
  'globalHeader.avatar.changePwd': 'Change Password',
  'globalHeader.changePwd.title': 'Change Password',
  'globalHeader.changePwd.oldPassword': 'Old Password',
  'globalHeader.changePwd.oldPassword.required': 'Please enter old password',
  'globalHeader.changePwd.newPassword': 'New Password',
  'globalHeader.changePwd.newPassword.required': 'Please enter new password',
  'globalHeader.changePwd.success': 'Password changed, please log in again',
};
